// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable import/named, react-hooks/set-state-in-effect */

import React, { useEffect, useState } from "react";
import { Handles, Rail, Slider, SliderItem, Ticks, Tracks } from "react-compound-slider";
import { MFASlider } from "./MFASlider";
import Tooltip from "rc-tooltip";

interface TickProps {
	tick: SliderItem;
	text: string;
	onClick: () => void;
}

export const Tick: React.FC<TickProps> = ({ tick, text, onClick }) => {
	return (
		<div onClick={onClick}>
			<div
				style={{
					position: "absolute",
					marginTop: -0.5,
					marginLeft: 12,
					height: 1,
					width: 6,
					backgroundColor: "var(--text)",
					top: `${tick.percent}%`,
				}}
			/>
			<div
				style={{
					position: "absolute",
					marginTop: -5,
					marginLeft: 20,
					lineHeight: "10px",
					fontSize: 10,
					top: `${tick.percent}%`,
					color: "var(--text)",
				}}
			>
				{text}
			</div>
		</div>
	);
};

type Props = {
	currentOpacity: number;
	onChange: (opacity: number) => void;
	rootStyle?: React.CSSProperties;
};

export const TransparencySlider = ({ currentOpacity, onChange, rootStyle }: Props) => {
	const [value, setValue] = useState(currentOpacity);

	useEffect(() => {
		setValue(currentOpacity);
	}, [value, currentOpacity]);

	const handleChange = (value: number) => {
		setValue(value);
		onChange(value);
	};

	return (
		<Tooltip
			placement="top"
			mouseEnterDelay={0}
			mouseLeaveDelay={0}
			trigger="hover"
			motion={{ motionName: "rc-tooltip-zoom" }}
			overlay={<div>Opacity</div>}
		>
			<div style={{ width: "fit-content", ...rootStyle }}>
				<Slider
					className="mfaSlider vertical"
					// rootStyle={rootStyle}
					values={[currentOpacity]}
					domain={[0, 1]}
					step={0.01}
					vertical
					reversed
					onUpdate={(v) => handleChange(v[0])}
				>
					<Rail>
						{({ getRailProps }) => <MFASlider.SliderRail className="transparency" getRailProps={getRailProps} />}
					</Rail>
					<Handles>
						{({ handles, getHandleProps }) => (
							<div className="slider-handles">
								{handles.map((handle) => (
									<MFASlider.KeyboardHandle
										key={handle.id}
										handle={handle}
										domain={[0, 1]}
										getHandleProps={getHandleProps}
										vertical
									/>
								))}
							</div>
						)}
					</Handles>
					<Tracks left={false} right={false}>
						{({ tracks, getTrackProps }) => (
							<div className="slider-tracks">
								{tracks.map(({ id, source, target }) => (
									<MFASlider.Track key={id} source={source} target={target} getTrackProps={getTrackProps} />
								))}
							</div>
						)}
					</Tracks>
					<Ticks values={[0, 0.5, 1]}>
						{({ ticks }) => (
							<div className="slider-ticks">
								{ticks.map((tick) => (
									<Tick
										key={tick.id}
										tick={tick}
										text={(tick.value * 100).toFixed()}
										onClick={() => {
											handleChange(tick.value);
										}}
									/>
								))}
							</div>
						)}
					</Ticks>
				</Slider>
			</div>
		</Tooltip>
	);
};
